var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import Header from '@backoffice/components/layout/Header.vue';
import Menu from '@backoffice/components/layout/Menu.vue';
import { isCountingMode } from '@shared/utils/counting';
let DefaultLayout = class DefaultLayout extends Vue {
    constructor() {
        super(...arguments);
        this.isMenuOpened = false;
        this.keepAlivePages = ['UtilisateursIndex', 'ChiffrageIndex'];
    }
    get pageName() {
        return this.getRouteBaseName(this.$route);
    }
    get isCountingMode() {
        return isCountingMode();
    }
};
DefaultLayout = __decorate([
    Component({
        components: { Menu, Header },
        head() {
            return this.$nuxtI18nHead({ addDirAttribute: false, addSeoAttributes: true });
        },
    })
], DefaultLayout);
export default DefaultLayout;
